<template>
    <section class="content">
        <div class="container-fluid">
            <div class="block-header">
                <h2>NARASUMBER</h2>
            </div>
            <div class="row clearfix">
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <div class="card">
                        <div class="header">
                            <h2>
                                List Narasumber
                            </h2>
                            <ul class="header-dropdown m-r--5 m-t--10">
                                <router-link to="/main/narasumber/tambah" type="button" class="btn btn-primary waves-effect waves-button" v-waves.button>
                                    <i class="material-icons" style="color: #fff;">add_box</i>
                                    <span>Tambah</span>
                                </router-link>
                            </ul>
                        </div>
                        <div class="body">
                            <div class="table-responsive">
                                <table class="table table-bordered table-striped table-hover js-basic-example dataTable">
                                    <thead>
                                    <tr>
                                        <th>No.</th>
                                        <th>Nama</th>
                                        <th>Singkatan</th>
                                        <th>Aksi</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-if="isLoading">
                                        <td colspan="4" class="text-center"><i class="fa fa-spin fa-spinner"></i> Loading data...</td>
                                    </tr>
                                    <tr v-if="list == ''">
                                        <td colspan="4" class="text-center">Data tidak ditemukan</td>
                                    </tr>
                                    <tr v-if="!isLoading" v-for="(item, index) in list">
                                        <td>{{ ++index + ((currentPage-1)*perPage) }}</td>
                                        <td>{{ item.nama }}</td>
                                        <td>{{ item.singkatan }}</td>
                                        <td>
                                            <button @click="$router.push('/main/narasumber/edit/' + item.idNarasumber)" style="padding: 4px 8px;" type="button" class="btn bg-green waves-effect">
                                                <i class="material-icons">create</i>
                                            </button>
                                            <button @click="confirmDelete(item.idNarasumber)" style="padding: 4px 8px;" type="button" class="btn btn-danger waves-effect">
                                                <i class="material-icons">delete</i>
                                            </button>

                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                                <pagination :total-rows="result.totalElements" :per-page="result.size" v-model="currentPage"></pagination>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
  import api from '@/helper/api'
  import qs from 'qs'

  export default {
    name: 'ListNarasumber',
    data: function () {
      return {
        result: {},
        list: [],
        currentPage: 1,
        perPage: 10,
        search: '',
        modal: null,
        isLoading: true,
        link: '',
        tipe: '',
        nama: ''
      }
    },
    methods: {
      getData () {
        var params = []
        params.search = this.search
        params.page = this.currentPage - 1
        params.size = this.perPage

        this.isLoading = true

        api.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token')
        api.get('/narasumber?' + qs.stringify(params)).then((result) => {
          this.result = result.data
          this.list = result.data.content
          this.isLoading = false
        }).catch((ex) => {
          this.isLoading = false
        })
      },
      confirmDelete (id) {
        this.$swal({
          title: 'Konfirmasi',
          text: 'Anda yakin ingin menghapus data ini?',
          icon: 'warning',
          buttons: [
            true, {
              text: 'Ok',
              closeModal: false
            }
          ],
          dangerMode: true
        }).then(result => {
          if (result) this.delete(id)
        })
      },
      delete (id) {
        api.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token')
        api.delete('/narasumber/' + id).then((result) => {
          if (result.data.code === 200) this.$toastr.s('Data berhasil dihapus.')
          else this.$toastr.e('Gagal menghapus data, terjadi kesalahan pada server.')
          this.$swal.close()
          this.getData()
        }).catch((e) => {
          this.$toastr.e('Gagal menghapus data, terjadi kesalahan pada server.')
          this.$swal.close()
        })
      }
    },
    mounted: function () {
      this.getData()
    },
    watch: {
      currentPage (e) {
        this.getData()
      },
      perPage (e) {
        this.getData()
      },
      search (e) {
        this.getData()
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/view/Narasumber/ListNarasumber.vue?46001ede